<template>
  <!-- 案件委托 -->
  <div id="entrust">

    <section> <entrubanfrom  /> </section>

    <section> <entruproce  /> </section>

    <section class="w_fluid"> <entrutable  /> </section>


  </div>
</template>

<script>

import entrubanfrom from './child/entrubanfrom'//banner表单
import entruproce from './child/entruproce'//流程优势
import entrutable from './child/entrutable'//表格


export default {
  name: "entrust",
  components: {


    // 私
    entrubanfrom,
    entruproce,
    entrutable,

  },

};
</script>

<style lang="scss" scoped>
#entrust {
  background-color: #fff;
  .w_fluid{
      width: 100%;
      background-color: #F8F8F8;
  }
}
</style>
